export default "__VITE_ASSET__DmQAIcyW__"